import React from 'react'
import { LoadingStyled } from './styles'

const LoadingCircle = () => {
  return (
    <LoadingStyled className='loading' />
  )
}

export default LoadingCircle
